const Analytics = require('./analytics');
const StoreAvailabilityState = require('./storeavailability').State;
const StoreAvailabilityDeliveryType = require('./storeavailability').DeliveryType;
const uiSettings = require('./utils/UISettings');
const deliverySlotPicker = require('./delivery-slot-picker');

const helpers = {
  /** @param {Promise} cancellable
   @returns {Promise} */
  updateFeedback: function updateFeedback(feedback, type, postcodeOrLocation, label, info, state) {
    const labelElt = feedback.find('.emphase');
    const postcodeOrLocationElt = feedback.find('.postcode');
    const infoElt = feedback.find('.info');

    labelElt.text(label);

    postcodeOrLocationElt.text(postcodeOrLocation);

    infoElt.text('');
    if (info) {
      infoElt.html(info);
      infoElt.show();
    } else {
      infoElt.hide();
    }
  },
  showMainError: function showMainError(
    channelsPanel, locationSearchWrapper, channels, techError, help, mcdSwitchers, loader
  ) {
    channelsPanel.show();
    locationSearchWrapper.show();
    channels.hide();
    techError.show();
    locationSearchWrapper.removeClass('postcode-error-state');
    help.show();
    mcdSwitchers.hide();
    loader.hide();
  },
  offerProductDeliveryOptions: function offerProductDeliveryOptions(
    safetyStepEl, checkCollectInstead, countdownPlaceholder, showDeliveryBtn, deliverySlotsEl,
    freeDeliveryAddToBasketButton, deliveryLoader, productAvailability,
    updateProductDelivery, onDeliveryError
  ) {
    safetyStepEl.show();
    checkCollectInstead.hide();

    // TODO: rewrite after Redux is merged
    countdownPlaceholder.find('[data-component="countdown"]').each(function callback() {
      if ($(this).data('delivery-type') === 'next-day' &&
        $(this).data('product-type') === 'smallbox') {
        countdownPlaceholder.show();
        $(this).find('.countdown-wrapper').show();
      } else {
        $(this).find('.countdown-wrapper').hide();
      }
    });

    showDeliveryBtn.click((e) => {
      e.preventDefault();
      safetyStepEl.hide();
      deliverySlotsEl.hide();
      freeDeliveryAddToBasketButton.hide();
      checkCollectInstead.hide();
      countdownPlaceholder.hide();
      countdownPlaceholder.find('.countdown-wrapper').show();
      deliveryLoader.show();
      productAvailability.getProductDelivery(updateProductDelivery, onDeliveryError);
    });
  },

  setUndeliverableLinks: function setUndeliverableLinks(container, segmentData) {
    container.show();
    const segmentElt = container.find('.segment');
    segmentElt.attr('href', segmentData.url).text(segmentData.name);
  },

  updateProductDeliveriesSlot: function updateProductDeliveriesSlot(
    productAvailability, deliverySlots,
    deliveryLoader, countdownPlaceholder, checkCollectInstead, postcodeNewSelection,
    postcodeItemsInBasket, infoBox, deliverySlotsEl, freeDeliveryAddToBasketButtonPanel
  ) {
    deliverySlotPicker.receiveDeliverySlots(deliverySlots, productAvailability);
    deliveryLoader.hide();
    countdownPlaceholder.show();
    if (!productAvailability.isUncollectable()) {
      checkCollectInstead.show();
    }
    if (productAvailability.isSplitDelivery()) {
      countdownPlaceholder.hide();
      showHDPcInfoBox(
        postcodeNewSelection,
        postcodeItemsInBasket,
        productAvailability.getPreviousDeliveryLocation(),
        productAvailability.getLocation().location ||
        productAvailability.getLocation(),
        infoBox
      );
    }
    deliverySlotsEl.show();
    if (productAvailability.getProductType() === 'SMALLBOX') {
      freeDeliveryAddToBasketButtonPanel.show();
    }
  },

  createUndeliverableOutOfStockContent: function createUdeliverableOutOfStockContent(
    countdownPlaceholder, deliveriesContent, productAvailability
  ) {
    countdownPlaceholder.hide();
    // lots of messing around due to 2 form
    // elements an mcd-post co check having not error handling
    const infoEl = deliveriesContent.find('.mcd-feedback');
    infoEl.hide();

    const errorEl = deliveriesContent.find('.delivery-slots-disabled');
    errorEl.hide();

    const newElement = document.createElement('div');
    newElement.innerHTML =
      `<span class="emphase">${productAvailability.getDeliveryLabel()}</span>`;
    newElement.className = 'mcd-feedback center';

    deliveriesContent.each((i, currentFirstTabContentElement) => {
      currentFirstTabContentElement.insertBefore(
        newElement, currentFirstTabContentElement.childNodes[0]
      );
    });
  },

  trackAvailabilityAnalytics: function trackAvailabilityAnalytics(productAvailability) {
    Analytics.track(
      'PRODUCT_AVAILABILITY',
      productAvailability.getCollectionState(),
      productAvailability.getDeliveryState()
    );

    // dispatch digitalData event
    if (window.appState) {
      const action = {
        type: 'STORE_LOCATOR_STORES_FOUND',
        payload: {
          stores: productAvailability.getAvailableStores().map((store, index) => ({
            storeId: store.getStoreId(),
            storeStatus: getStoreStatus(productAvailability, index)
          })),
          location: productAvailability.getLocation()
        }
      };
      window.appState.dispatch(action);
    }
  }
};

function showHDPcInfoBox(
  postcodeNewSelection, postcodeItemsInBasket, prevPc, newPc, infoBox
) {
  Analytics.track('MULTIPLE_DELIVERY_LOCATIONS');
  postcodeNewSelection.text(prevPc);
  postcodeItemsInBasket.text(newPc);
  infoBox.show();
}

function getStoreStatus(productAvailability, storeIndex) {
  const availableStores = productAvailability.getAvailableStores();
  const store = availableStores[storeIndex];

  // Only Currys stores have pickUp property equals to true
  if (store.isPickUp()) {
    return 'CMO pickup point only';
  }

  // OUT_OF_STOCK is from http://confluence.dixons.co.uk/display/DBS/Final stockTypeEnum
  if (store.getStockAvailability() === 'OUT_OF_STOCK') {
    return 'Out of stock';
  }

  if (store.getAvailabilityType() === StoreAvailabilityDeliveryType.PAY_AND_COLLECT) {
    return 'Currys pay and collect';
  }

  if (store.getAvailabilityType() === StoreAvailabilityDeliveryType.RESERVE_AND_COLLECT ||
    store.getAvailabilityType() === StoreAvailabilityDeliveryType.PAY_AND_COLLECT_FROM_STORE_STOCK
  ) {
    return getStoreStatusForReserveAndCollect(store);
  }

  throw new Error("It wasn't possible to determine store status");
}

function getStoreStatusForReserveAndCollect(store) {
  const storeOpenState = store.getOpenState();
  const timeUntilOpen = store.getTimeUntilOpen();
  const timeUntilClosed = store.getTimeUntilClosed();

  if (storeOpenState === StoreAvailabilityState.CLOSED) {
    if (typeof timeUntilOpen === 'number' && timeUntilOpen > 0) {
      return 'Closed, opening today';
    }
    return 'Closed';

  }

  if (storeOpenState === StoreAvailabilityState.OPEN) {
    return 'Open';
  }

  // This branching is here to differ shorter statuses (e. g. 'Closed, opening soon')
  // and longer statuses with minutes info (e. g. '30 minutes until close')
  if (!uiSettings.get('component.mcd.store_opening_hours.availability_countdown')) {
    if (storeOpenState === StoreAvailabilityState.CLOSING_SOON) {
      return 'Open, closing soon';
    }

    if (storeOpenState === StoreAvailabilityState.OPENING_SOON) {
      return 'Closed, opening soon';
    }
  } else {
    if (storeOpenState === StoreAvailabilityState.CLOSING_SOON) {
      return `${getDisplayedTime(timeUntilClosed)} minutes until close`;
    }

    if (storeOpenState === StoreAvailabilityState.OPENING_SOON) {
      return `${getDisplayedTime(timeUntilOpen)} minutes until open`;
    }
  }

  throw new Error("It wasn't possible to determine store status for Reserve&Collect");
}

/**
 * Gathering minutes for longer statuses
 *
 * @param timeUntilOpenOrClosed time remainining until opening or closing of the store
 * @returns minutes for longer statuses
 */
function getDisplayedTime(timeUntilOpenOrClosed) {
  const cutoffTimes = window.App.settings.get('stores')['cutoff-time'].sort(
    (a, b) => a - b
  );

  return cutoffTimes.filter(
    (threshold) => timeUntilOpenOrClosed <= threshold
  )[0];
}

module.exports = helpers;
